<style>

.card{
  position: relative;
  color: white;
}

.info{
  margin: 20px;
}
.name{
  font-size: 30px;
}
.distance{
  font-style: italic;
}

.common-interests-headline{
  font-weight: 500;
  font-style: italic;
  text-align: center;
}
.match-score{
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.view-all{
  font-size: 14px;
  font-style: italic;
  text-align: center;
}
img{
  object-fit: cover;
  width: 100%;
}

.approve-skip-buttons{
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  /* background-color: rgba(0,0,0,0.8); */
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 20px 0;
}
.skip{
  grid-column: 1;
  padding: 0 20px;
}
.approve{
  grid-column: 2;
  padding: 0 20px;
  text-align: right;
}
.icon-clear{
  font-size: 41px;
}
.icon-check{
  font-size: 41px;
}
button{
  border-radius: 15px;
  border-width: 1px;
  padding: 0 20px;
}
button.skipb{
  background-color: black;
  color: white;
  box-shadow: 0 0 5px #333;
}
button.skipb:hover{
  background-color: white;
  color: black;
}
button.approveb{
  background-color: white;
  color: black;
  box-shadow: 0 0 5px #333;
}
button.approveb:hover{
  background-color: black;
  color: white;
}

.about-me{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 15px 10px;
}
.bio{
  margin: 10px;
}
.common-interests{
  font-family: Sansation;
  font-size: 24px;
  font-style: italic;
  margin: 35px 10px 15px 10px;
}

.spinner{
  text-align: center;
  margin: 10px;
}

.sub-item{
  height: 150px;
  text-align: center;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-clip: border-box;
  background-size: cover;
  border-radius: 11px;
  border: 1px black solid;
  margin: 0 5px 20px 14px;
}
.sub-item-text{
  margin-top: 58px;
  font-size: 26px;
  font-weight: bold;
  text-shadow: 1px 1px 3px rgba(0,0,0,1);
}

.question{
  margin: 28px;
}
.question-answer{
  margin: 0 0 0 9px;
}
.question-slider{
  margin: 10px 16px;
}

.me, .them{
  display: inline-block;
  height: 15px;
  width: 15px;
  border-radius: 20px;
  background-color: #00d1ff;
}
.them{
  background-color: #fff500;
}
</style>

<Auth bind:this="{auth}"></Auth>

<Header 
buttons="{ [ {icon: 'icon-more2', text: 'Settings', callback: 'settings', disabled: false, }, ] }"
leftIcon="{ {icon: 'icon-heart3', text: 'Friends', callback: 'friends', disabled: false, } }"
on:friends="{ () => push('/friends-incoming') }">Find Friends</Header>
<div class="has-header"></div>


{#if message}

<h6>{message}</h6>
<!-- <div class="spinner"><Spinner spin="{false}"></Spinner></div> -->
<div class="spinner"><Spinner></Spinner></div>
<div class="center small">this might take a minute</div>
{:else if noFriend}

<h6>Looks like there aren't any more people to search.</h6>

{:else}

<!-- profile -->
<div class="card">
  <img src="https://routes.hot0.workers.dev/fi/{localStorage.getItem('cookie')}/{localStorage.getItem('csrf')}/{fuid}/{photo}" alt="" class="img">
  
  {#if showSkipApproveButtons}
    <div class="approve-skip-buttons">
      <div class="skip"><button class="skipb" on:click="{skip}"><i class="icon-clear"></i></button></div>
      <div class="approve"><button class="approveb" on:click="{approve}"><i class="icon-check"></i></button></div>
    </div>
  {/if}
</div>

<div class="info">
  <div class="name"><strong>{name}</strong> {age}</div>
  <div class="distance">{distance} miles away</div>
</div>

<div class="common-interests-headline">Match Percentage</div>
<div class="match-score">{matchScore}%</div>
<VennMatch match="{matchScore}"></VennMatch>
<!-- <div class="view-all">tap to view all</div> -->

<div class="about-me">About Me</div>
<div class="bio">{bio}</div>

<div class="common-interests">Common Interests</div>
{#each commonInterests as item}
  <div class="sub-item" style="background-image: url('/categories/{item.p}.jpg');">
    <div class="sub-item-text">{item.t}</div>
  </div>
{/each}

<div class="common-interests">Match Questions</div>

{#each questions as item, index}

  <div class="question">Q: {Questions[index].question}</div>
  <div class="question-answer"><div class="me"></div> Me: <strong>{ item.me != 0 ? Questions[index].answers[ item.me - 1 ] : 'No Answer' }</strong></div>
  <div class="question-answer"><div class="them"></div> Them: <strong>{ item.them != 0 ? Questions[index].answers[ item.them - 1 ] : 'No Answer' }</strong></div>
  <div class="question-slider">
    <MatchSlider me="{item.me}" them="{item.them}"></MatchSlider>
  </div>
  
{/each}


{/if}


<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location} from 'svelte-spa-router';
export let params = {};

import Auth from "../interfaces/Auth.svelte";
let auth;

import {getBoundsFromLatLong, calcDistance} from "../helpers/Geo.js";
import {matchMeWith} from "../helpers/Match.js";
import ShareCrypto from "../helpers/ShareCrypto.js";
import DateTime from "../helpers/DateTime.js";
import tinterests from "../helpers/InterestCategories.js";
import Questions from "../helpers/Questions.js";

import Header from "../components/Header.svelte";
import ActionBar from "../components/ActionBar.svelte";
import VennMatch from "../components/VennMatch.svelte";
import Spinner from "../components/Spinner.svelte";
import MatchSlider from "../components/MatchSlider.svelte";

let fuid = "";
let photo = "";
let name = "";
let age = 0;
let matchScore = 0;
let distance = 0;
let bio = "";
let commonInterests = [];
let questions = [];

let message = "Warming up...";
let noFriend = false;
let me = null;
let bounds = {};
let minimumMatchScore = 40;

let showSkipApproveButtons = true;
// friend uid

let allInterests = [];

import { onMount } from "svelte";
onMount(async () => {
  
  if ("sent" in params) {
    if (params.sent == "s") {
      showSkipApproveButtons = false;
    }
  }
  
  allInterests = tinterests.convert();
  
  me = localStorage.getItem("store");
  me = JSON.parse(me);
  
  // console.log("me:", me);

  // miles to kilometers
  let radius = (me.distanceFriends / 2) * 1.60934;
  // console.log("radius:", radius);
  bounds = getBoundsFromLatLong(me.lat, me.long, radius);
  // console.log("bounds:", bounds);

  // console.log("params:", params);
  
  if ("uid" in params) {
    // console.log("trueeeee:", );
    message = "Loading...";
    viewFriend();
  } else {
    loadNewFriend();
  }
  
  // setTimeout( loadFriend, 1000);
  // setTimeout( () => {message = ""; noFriend = true}, 3000);
});


async function loadFriend(uid) {
  // load friend
  let friend = await auth.post("loadFriend", {uid: uid}, false);
  friend = JSON.parse(friend);
  let them = JSON.parse( ShareCrypto.decrypt(friend) );
  // console.log("them:", them);
  
  // console.log("me:", me);
  
  let tMatchScore = matchMeWith(me, them, 50, DateTime.mysqlDateNow() );
  
  // console.log("----MatchScore:", tMatchScore);
  
  return {matchScore: tMatchScore, them: them};
}


async function showProfile(tMatchScore, them) {
  // load profile
  message = "";
  fuid = them.uid;
  photo = them.photoIds[0];
  name = them.name;
  age = DateTime.getAge(them.birthday);
  matchScore = tMatchScore;
  bio = them.bio;
  
  distance = calcDistance(me, them, true);
  
  let interestIds = []
  for (let i in me.interests) {
    if (them.interests.includes( me.interests[i] ) == true ) {
      interestIds.push(me.interests[i]);
    }
  }
  
  // console.log("interestIds:", interestIds);

  commonInterests = [];
  
  // loop through allInterests and pull out the image filename
  for (let i in allInterests) {
    if (allInterests[i].h == 1 && interestIds.includes(allInterests[i].i) == true) {
      commonInterests.push( {p: allInterests[i].p/* photo */, t: allInterests[i].t/* text */} );
    }
  }
  // console.log("commonInterests:", commonInterests);
  
  questions = [];
  for (let i in me.questions) {
    questions.push({me: me.questions[i], them: them.questions[i]})
  }
  
  // console.log("questions:", questions);
  
}


async function viewFriend() {
  let {matchScore, them} = await loadFriend(params.uid);
  showProfile(matchScore, them);
}


async function loadNewFriend() {
  message = "Looking for a friend...";
  
  try {
    
    // top left: 33.845, -118.764
    // bottom right: 33.903, -117.104
    
    // console.log("bottom left: " + bounds.latMin + ", " + bounds.longMin);
    // console.log("middle: " + me.lat + ", " + me.long);
    // console.log("top right: " + bounds.latMax + ", " + bounds.longMax);
    
    let body = {
      // top left
      latMin: bounds.latMin,
      longMin: bounds.longMin,
      
      // bottom right
      latMax: bounds.latMax,
      longMax: bounds.longMax,
    }
    
    // console.log("body:", body);
    
    let found = await auth.post("findFriend", body, false);
    found = JSON.parse(found);
    // let found = "e8c31b1e7b41ea08";
    // console.log("findFriend:", found);
    
    if (found.u != "-") {
      
      // load friend
      // let friend = await auth.post("loadFriend", {uid: found.u}, false);
      // friend = JSON.parse(friend);
      // let them = JSON.parse( ShareCrypto.decrypt(friend) );
      // console.log("them:", them);
      
      // console.log("me:", me);
      
      // let tMatchScore = matchMeWith(me, them, 50, DateTime.mysqlDateNow() );
      
      // console.log("tMatchScore:", tMatchScore);
      
      let {matchScore, them} = await loadFriend(found.u);
      
      if (matchScore > 0 && matchScore > minimumMatchScore) {
        
        showProfile(matchScore, them);
        
        // hold friend
        if (found.t != "held") {
          let hold = await auth.post("holdFriend", {fuid: them.uid}, false);
          // console.log("hold:", hold);
        } else {
          // console.log("held");
        }
        
      } else {
        // console.log("loadNewFriend");
        setTimeout(loadNewFriend, 1);
      }
      
    } else {
      message = ""; 
      noFriend = true;
    }
    
  } catch (error) {
    console.log("error:", error);
    
  }
}


async function skip() {
  
  try {
    let skip = await auth.post("skipFriend", {fuid: fuid}, false);
    // console.log("skip:", skip);
    
    if ("uid" in params && params.uid != "") {
      // if we were sent here from FriendsIncoming, then go back
      pop();
    } else {
      // start loadFriend again
      loadNewFriend();
    }
    
  } catch (error) {
    console.log("error:", error);
  }

}


async function approve() {
  
  try {
    let approve = await auth.post("approveFriend", {fuid: fuid}, false);
    // console.log("approve:", approve);
    
    if ("uid" in params && params.uid != "") {
      // if we were sent here from FriendsIncoming, then go back
      pop();
    } else {
      // start loadFriend again
      loadNewFriend();
    }
    
  } catch (error) {
    console.log("error:", error);
  }
  
}

</script>